import React from 'react';
import { Link } from 'react-router-dom';
import type { Property } from '../../services/api';
import { Section } from './Section';

/**
 * 담당자 없는 현장(대구·경북 외 등)의 상세 하단 — 고객용 문의폼 대신 '사이드 문의' 안내 (2026-10-06 대표).
 * "폼이 있으면 분양인이 아니면 문의 남기는 곳이라 착각할 수 있다 → 폼을 숨기고 버튼으로 /business-inquiry 이동"
 * 사이드 = 담당자 없는 현장을 맡고 싶은 분양 상담사·대행사의 문의. 버튼은 유형(사이드)·현장을 미리 채워 넘긴다.
 */
export const SideRecruitCard: React.FC<{ property: Pick<Property, 'id' | 'title'> }> = ({ property }) => {
  const q = new URLSearchParams({ type: 'side', property: property.title, pid: String(property.id) });
  return (
    <Section id="side-inquiry" eyebrow="사이드 문의">
      <div className="flex flex-col gap-3 rounded-ca-2xl border border-ca-line bg-frame p-5 md:p-6">
        <p className="text-[16px] font-bold leading-6 text-ink">분양 상담사·대행사이신가요?</p>
        <p className="text-[13.5px] leading-[21px] text-body">
          이 현장은 현재 담당 상담사가 없습니다. 현장을 맡고 싶으시면 사이드 문의를 남겨 주세요.
        </p>
        <Link
          to={`/business-inquiry?${q.toString()}`}
          className="flex h-[50px] items-center justify-center rounded-ca-md bg-ink px-4 text-[14px] font-extrabold text-white"
        >
          사이드 문의하기
        </Link>
      </div>
    </Section>
  );
};

export default SideRecruitCard;
